import React, { useEffect, useState } from 'react';
import styles from './TemplatesPage.module.css';
import { apiFetch } from '../api/client';
import { supabase } from '../auth/supabase';

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isPublic, setIsPublic] = useState(true);
  const [error, setError] = useState('');
  const getToken = async () => (await supabase.auth.getSession()).data.session?.access_token;

  const load = async () => {
    try {
      const t = await apiFetch('/templates', {}, getToken);
      setTemplates(t);
    } catch (e) {
      setError(e.message);
    }
  };
  useEffect(() => { load(); }, []);

  const upload = async () => {
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('title', title || file.name);
    fd.append('description', description);
    fd.append('is_public', String(isPublic));
    try {
      await apiFetch('/templates', { method: 'POST', body: fd }, getToken);
      setFile(null); setTitle(''); setDescription(''); setIsPublic(true);
      load();
    } catch (e) {
      alert(e.message || 'Upload failed');
    }
  };

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Templates</h1>
      <div className={styles.uploadBar}>
        <input type="file" accept=".pptx,.docx" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        <input className={styles.input} placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <input className={styles.input} placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
        <label className={styles.chk}><input type="checkbox" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} /> Public</label>
        <button className={styles.upload} disabled={!file} onClick={upload}>Upload Template</button>
      </div>
      {error && <div className={styles.error}>{error}</div>}
      <div className={styles.list}>
        {templates.map((t) => (
          <div key={t.id} className={styles.row}>
            <div>
              <div className={styles.rowTitle}>{t.title}</div>
              <div className={styles.rowDesc}>{t.description || t.file_path}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
